// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [15,[2]],
		"/(app)/admin": [16,[2,3]],
		"/(app)/admin/analytics": [17,[2,3]],
		"/(app)/admin/analytics/[tab]": [18,[2,3]],
		"/(app)/admin/credits": [19,[2,3,4]],
		"/(app)/admin/evaluations": [20,[2,3]],
		"/(app)/admin/evaluations/[tab]": [21,[2,3]],
		"/(app)/admin/functions": [22,[2,3]],
		"/(app)/admin/functions/create": [23,[2,3]],
		"/(app)/admin/functions/edit": [24,[2,3]],
		"/(app)/admin/settings": [25,[2,3]],
		"/(app)/admin/settings/[tab]": [26,[2,3]],
		"/(app)/admin/users": [27,[2,3]],
		"/(app)/admin/users/[tab]": [28,[2,3]],
		"/(app)/ai-filing": [29,[2,5]],
		"/(app)/ai-filing/detail/[entity]/[id]": [30,[2,5]],
		"/(app)/ai-filing/styleguide": [31,[2,5]],
		"/(app)/announcements": [32,[2]],
		"/auth": [73],
		"/auth/reset-password": [74],
		"/(app)/automations": [33,[2,6]],
		"/(app)/automations/[id]": [34,[2,6]],
		"/(app)/calendar": [36,[2]],
		"/(app)/channels/[id]": [37,[2]],
		"/(app)/c/[id]": [35,[2]],
		"/(app)/enterprise": [38,[2,7]],
		"/error": [75],
		"/(app)/explore": [39,[2]],
		"/(app)/folders/[folderId]": [40,[2]],
		"/(app)/home": [41,[2,8]],
		"/(app)/ingredients": [42,[2,9]],
		"/(app)/notes": [43,[2,10]],
		"/(app)/notes/new": [45,[2,10]],
		"/(app)/notes/[id]": [44,[2,10]],
		"/payment-terms": [76,[13]],
		"/payments/result": [77,[14]],
		"/(app)/playground": [46,[2,11]],
		"/(app)/playground/completions": [47,[2,11]],
		"/(app)/playground/images": [48,[2,11]],
		"/privacy": [78],
		"/s/[id]": [79],
		"/terms": [80],
		"/(app)/test-item": [49,[2]],
		"/watch": [81],
		"/(app)/workspace": [50,[2,12]],
		"/(app)/workspace/favorites": [51,[2,12]],
		"/(app)/workspace/formula-tasks": [52,[2,12]],
		"/(app)/workspace/formula-tasks/[taskId]": [53,[2,12]],
		"/(app)/workspace/formula-tasks/[taskId]/candidates": [54,[2,12]],
		"/(app)/workspace/formula-tasks/[taskId]/workbench": [55,[2,12]],
		"/(app)/workspace/functions/create": [56,[2,12]],
		"/(app)/workspace/knowledge": [57,[2,12]],
		"/(app)/workspace/knowledge/create": [59,[2,12]],
		"/(app)/workspace/knowledge/[id]": [58,[2,12]],
		"/(app)/workspace/models": [60,[2,12]],
		"/(app)/workspace/models/create": [61,[2,12]],
		"/(app)/workspace/models/edit": [62,[2,12]],
		"/(app)/workspace/prompts": [63,[2,12]],
		"/(app)/workspace/prompts/create": [65,[2,12]],
		"/(app)/workspace/prompts/[id]": [64,[2,12]],
		"/(app)/workspace/skills": [66,[2,12]],
		"/(app)/workspace/skills/create": [67,[2,12]],
		"/(app)/workspace/skills/edit": [68,[2,12]],
		"/(app)/workspace/tools": [69,[2,12]],
		"/(app)/workspace/tools/create": [70,[2,12]],
		"/(app)/workspace/tools/edit": [71,[2,12]],
		"/(app)/workspace/upload": [72,[2,12]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);